import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Sale } from '@/pages/MinhasVendas';
import { DialogTitle } from '@radix-ui/react-dialog';

interface ReceiptModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedSale: Sale | null;
  userData: any;
  onDownloadReceipt: () => void;
}

export function ReceiptModal({
  isOpen,
  onClose,
  selectedSale,
  userData,
  onDownloadReceipt
}: ReceiptModalProps) {
  if (!selectedSale) return null;

  const formatCurrency = (amount: number): string => {
    return (amount / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const formatDateReceipt = (dateString: string): string => {
    return format(new Date(dateString), 'dd/MM/yyyy', { locale: ptBR });
  };

  const formatTimeReceipt = (dateString: string): string => {
    return format(new Date(dateString), 'HH:mm', { locale: ptBR });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogTitle className='sr-only'>Recibo da Venda</DialogTitle>
      <DialogContent className="max-w-md p-0">        
        <div>
          <div id="receipt-content" className="p-8" style={{ backgroundColor: '#fcfae7' }}>
            <div className="text-center mb-4">
              <img 
                src="/v2/logos/logo-horizontal.png" 
                alt="Logo" 
                style={{ width: '160px' }} 
                className="mx-auto"
              />
            </div>
            <hr className="my-4 border-gray-300" />
            <h2 className="text-center text-lg font-bold mb-4">
              RECIBO VENDA #{selectedSale.codepagarme || `XDINF${selectedSale.id}`}
            </h2>
            <hr className="my-4 border-gray-300" />
            
            <div className="space-y-4">
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-bold text-sm">Data:</p>
                  <p className="text-sm">{formatDateReceipt(selectedSale.date_created)}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-sm">Hora:</p>
                  <p className="text-sm">{formatTimeReceipt(selectedSale.date_created)}</p>
                </div>
              </div>
              
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-bold text-sm">Valor:</p>
                  <p className="text-sm">{formatCurrency(selectedSale.amount)}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-sm">Mét. Pagamento:</p>
                  <p className="text-sm">
                    {selectedSale.payment_method === 'pix' 
                      ? 'Pix' 
                      : `Cartão Créd. (${selectedSale.installments}x)`
                    }
                  </p>
                </div>
              </div>
              
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-bold text-sm">Vendedor(a):</p>
                  <p className="text-sm">{userData?.nome_razao_social || 'N/A'}</p>
                </div>
                {selectedSale.nome_cliente && (
                  <div className="text-right">
                    <p className="font-bold text-sm">Cliente:</p>
                    <p className="text-sm">{selectedSale.nome_cliente}</p>
                  </div>
                )}
              </div>
            </div>
            
            <hr className="my-4 border-gray-300" />
            <div className="text-center">
              <p className="text-xs mb-1">X do Infinito Comércio Eletrônico Ltda ©</p>
              <p className="text-xs mb-2">16.869.140/0001-30</p>
              <p className="text-xs opacity-40">Este slip não possui valor jurídico</p>
            </div>
          </div>
          
          <div className="flex gap-2 pt-4 bg-[#fcfae7] p-4">
            <Button 
              onClick={onDownloadReceipt}
              className="flex-1"
            >
              <Download className="h-4 w-4 mr-2" />
              Baixar Recibo
            </Button>
            <Button 
              variant="outline" 
              onClick={onClose}
              className="flex-1"
            >
              Fechar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}